import styled from 'styled-components'

import MuiList from '@material-ui/core/List'

const List = styled(MuiList)`
  margin-right: 50px;
`

export default List
